import { DweenTimeUnitEnum } from "utils/time-utils";
import { DatasetChartProps, DatasetLoadingConf, LineEditorLoadingTypes } from "../charts/interfaces";
import { XAxisType } from "../charts/bar-chart/bar-chart-utils";

export enum LoadConfigUnitTypes {
  LAGUNIT = "lagUnit",
  LEADUNIT = "leadUnit",
  ALIGNUNIT = "alignUnit",
}

export const defaultLoadConf: DatasetLoadingConf = {
  type: LineEditorLoadingTypes.TIME,
  lead: 0,
  lag: 6,
  leadUnit: DweenTimeUnitEnum.HOURS,
  lagUnit: DweenTimeUnitEnum.HOURS,
  alignUnit: DweenTimeUnitEnum.MINUTES,
};

export const defaultDatasetLineChartConfig: DatasetChartProps = {
  title: "",
  xAxisType: XAxisType.DATE,
  height: 400,
  showDateSelection: true,
  hideRefresh: false,
  loadConf: defaultLoadConf,
  updateFrequency: 5,
  datasets: [],
  toggleTracesGrouping: true,
  timeAxisStepSeconds: 0,
};
